import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LEGACY_TOKEN_KEY = "aximo_client_token";

const ClientAuthContext = createContext(null);
const api = axios.create({ baseURL: API, withCredentials: true });

export function ClientAuthProvider({ children }) {
    const [client, setClient] = useState(null);
    const [loading, setLoading] = useState(true);

    const logout = useCallback(async () => {
        try {
            await api.post("/clients/logout");
        } catch {
            /* ignore */
        }
        localStorage.removeItem(LEGACY_TOKEN_KEY);
        setClient(null);
    }, []);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const { data } = await api.get("/clients/me");
                if (!cancelled) setClient(data);
            } catch {
                const legacy = localStorage.getItem(LEGACY_TOKEN_KEY);
                if (legacy) {
                    try {
                        const { data } = await axios.get(`${API}/clients/me`, {
                            headers: { Authorization: `Bearer ${legacy}` },
                        });
                        if (!cancelled) setClient(data);
                    } catch {
                        localStorage.removeItem(LEGACY_TOKEN_KEY);
                    }
                }
            } finally {
                if (!cancelled) setLoading(false);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, []);

    const _postAndHydrate = async (path, body) => {
        const { data } = await api.post(path, body);
        localStorage.setItem(LEGACY_TOKEN_KEY, data.access_token);
        const me = await api.get("/clients/me");
        setClient(me.data);
        return me.data;
    };

    const login = (email, password) =>
        _postAndHydrate("/clients/login", { email, password });

    const setupPassword = (token_value, password) =>
        _postAndHydrate("/clients/setup-password", { token: token_value, password });

    const token = client
        ? localStorage.getItem(LEGACY_TOKEN_KEY) || "cookie"
        : null;

    return (
        <ClientAuthContext.Provider
            value={{ token, client, loading, login, logout, setupPassword }}
        >
            {children}
        </ClientAuthContext.Provider>
    );
}

export const useClientAuth = () => useContext(ClientAuthContext);
